export default __webpack_public_path__ + "static/media/Gotham-Light.d8bf4f56.otf";